import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Box, Text } from "@chakra-ui/react";
import Layout from "../../../components/dashboard/Layout";
import AddStudent from "../../../containers/admin/students/models/add-student";
import ShowPassword from "../../../containers/admin/students/models/show-password";
import StudentReport from "../../../containers/admin/students/models/student-report";
import UserQRCode from "../../../containers/admin/students/models/user-qr-code";
import SearchBar from "../../../containers/admin/students/searchbar";
import StudentsBySubjectTable from "../../../containers/admin/students/students-by-subject-table";
import AddSubjectAdmin from "../../../containers/admin/teachers/models/add-subject-admin";
import ShowSubjectAdminData from "../../../containers/admin/students/models/show-subject-admin-data";
import { getTeacherSubjectsRequest } from "../../../modules/admin-modules/teachers/Actions";
import Select from "react-select";
const StudentsBySubject = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  
  const model = useSelector((state) => state.model.isOpen18);
  const teacherSubjects = useSelector((state) => state.teachers.teacherSubjects);
  const [addedStudent, setAddedStudent] = useState({});
  const [addedSubjectAdmin, setAddedSubjectAdmin] = useState({});
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSubjectId, setSelectedSubjectId] = useState("");

  // Get subject_id from URL params
  const subjectIdFromParams = searchParams.get("subject_id");

  useEffect(() => {
    // Fetch teacher subjects when component mounts
    dispatch(getTeacherSubjectsRequest());
  }, [dispatch]);

  useEffect(() => {
    // Set selected subject from URL params
    if (subjectIdFromParams) {
      setSelectedSubjectId(subjectIdFromParams);
    }
  }, [subjectIdFromParams]);

  const handleSubjectChange = (subjectId) => {
    setSelectedSubjectId(subjectId);
    if (subjectId) {
      setSearchParams({ subject_id: subjectId });
    } else {
      setSearchParams({});
    }
  };

  const teacherSubjectsOptions = teacherSubjects?.data?.map((subject) => ({
    value: subject?.subject?.id,
    label: subject?.subject?.name,
  }));

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  return (
    <Layout>
      {/* Custom header for students by subject */}
      <Box w="100%" my={{ base: "50px", md: "30px" }}>
        <Text
          fontSize="24px"
          fontWeight="600"
          color="main_1"
          mb="20px"
        >
          الطلاب حسب المادة
        </Text>
        
        {/* Subject Selector */}
        <Box w="100%" mb="20px">
          <Text fontSize="16px" fontWeight="500" color="main_1" mb="10px">
            اختر المادة:
          </Text>
          <Box w="50%">
          <Select
            options={teacherSubjectsOptions}
            styles={colourStyles}
            onChange={(e) => handleSubjectChange(e.value)}
            />
          </Box>
        </Box>
      </Box>

      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        setSearchTerm={setSearchTerm}
      />

      {/* Only show table if subject is selected */}
      {selectedSubjectId && (
        <StudentsBySubjectTable
          setAdd={setAdd}
          setSelectedData={setSelectedData}
          searchTerm={searchTerm}
          selectedSubjectId={selectedSubjectId}
        />
      )}

      {!selectedSubjectId && (
        <Box 
          w="100%" 
          textAlign="center" 
          mt="50px" 
          p="20px" 
          bg="gray.50" 
          borderRadius="md"
        >
          <Text fontSize="18px" color="gray.600">
            يرجى اختيار مادة لعرض الطلاب
          </Text>
        </Box>
      )}

      <AddStudent
        isAdd={isAdd}
        data={selectedData}
        setAddedStudent={setAddedStudent}
      />
      <UserQRCode data={selectedData} setSelectedData={setSelectedData} />
      <ShowPassword data={addedStudent} />
      <AddSubjectAdmin
        isAdd={true}
        data={selectedData}
        setSelectedData={setSelectedData}
        setAddedSubjectAdmin={setAddedSubjectAdmin}
      />
      <ShowSubjectAdminData data={addedSubjectAdmin} />
      {model && (
        <StudentReport
          student_id={selectedData?.id}
          selectedData={selectedData}
        />
      )}
    </Layout>
  );
};

export default StudentsBySubject;
